export { default } from './PaymentModalContent';
